<template lang="pug">
.cotas
  l-geoJson(
    v-if="!hideFloodZones"
    :geojson="floodZones.sur"
    :options="options"
    :optionsStyle="styleFunction"
  )
  l-geoJson(
    v-if="show"
    :geojson="floodZones.norte"
    :options="options"
    :optionsStyle="styleFunction"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import theme from '@/theme.js'

export default {
  data () {
    return {
      options: {
        filter: (feature, layer) => feature.geometry,
        onEachFeature: (feature, layer) => {
          layer.bringToBack()
        }
      }
    }
  },
  methods: {
    styleFunction () {
      return theme.styles.cotas
    }
  },
  computed: {
    ...mapGetters([ 'floodZones', 'hideFloodZones' ]),
    show () {
      return !!(!this.hideFloodZones && this.floodZones && this.floodZones.norte)
    }
  }
}
</script>
